import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import { accountKeys } from './accounts';
import { digitalCoachesKeys } from './digital-coaches';
import { invitationsKeys } from './invitations';
import { usersKeys } from './users';

export const keys = mergeQueryKeys(invitationsKeys, usersKeys, digitalCoachesKeys, accountKeys);
